/**
 * Catálogo de tabelas do relatório por canal (UI, Excel, impressão).
 * @see projects/drheranca/especificacao/TABELAS_RELATORIO_CANAIS.md
 */
import type { ReportTableRegistryEntry } from './types';

export const REPORT_TABLE_REGISTRY: ReportTableRegistryEntry[] = [
  {
    tableId: 'composicao-patrimonio',
    label: 'Composição do patrimônio',
    description: 'Bens do espólio, dívidas e patrimônio líquido (data do óbito).',
    channels: {
      ui: ['Relatório → Resumo → Tabela de Composição do Patrimônio'],
      excel: 'Composição',
      print: ['Resumo — composição patrimonial'],
    },
  },
  {
    tableId: 'bases-avaliacao',
    label: 'Bases de avaliação por bem',
    description: 'Três bases de valor por bem (óbito, escritura, IR/partilha).',
    channels: {
      ui: ['Relatório → Resumo → card Composição (abaixo da tabela principal)'],
      excel: 'Bases avaliação',
      print: ['Resumo — composição patrimonial (mesma folha)'],
    },
  },
  {
    tableId: 'partilha-matrix',
    label: 'Matriz de partilha por pessoa',
    description: 'Quinhão bruto, deduções e total líquido por beneficiário.',
    channels: {
      ui: ['Relatório → Resumo → Matriz de Partilha por Pessoa'],
      excel: 'Partilha',
      print: ['Matriz de partilha por pessoa'],
    },
  },
  {
    tableId: 'calculo-por-pessoa',
    label: 'Detalhamento de cálculo por pessoa',
    description: 'Breakdown do total líquido (quinhão bem a bem + deduções).',
    channels: {
      ui: ['Relatório → Resumo da Partilha → Detalhamento de cálculo por pessoa'],
      excel: 'Cálculo por pessoa',
      print: ['Detalhamento de cálculo por pessoa'],
    },
  },
  {
    tableId: 'modo-partilha-acordo',
    label: 'Modo de partilha aplicado',
    description: 'Matriz bem × pessoa do acordo doação/usufruto (SP).',
    channels: {
      ui: ['Relatório → Resumo → Modo de partilha aplicado'],
      excel: 'Modo de partilha',
      print: ['Modo de partilha aplicado'],
    },
    condition: "calculos.modoPartilhaAplicado === 'acordo_doacao_usufruto'",
  },
  {
    tableId: 'despesas-informativas',
    label: 'Despesas informativas',
    description: 'Despesas já pagas — não afetam o cálculo.',
    channels: {
      ui: ['Relatório → Patrimônio/Dívidas → Despesas já processadas'],
      excel: 'Despesas informativas',
      print: ['Documento completo → Dívidas e doações'],
    },
    condition: 'calculos.despesasInformativas.length > 0',
  },
  {
    tableId: 'itens-fora-escopo',
    label: 'Itens fora do escopo',
    description: 'Registro histórico — ignorados no cálculo.',
    channels: {
      ui: ['Relatório → Patrimônio/Dívidas → Itens fora do escopo'],
      excel: 'Itens fora do escopo',
      print: ['Documento completo → Dívidas e doações'],
    },
    condition: 'calculos.dividasIgnoradas.length > 0',
  },
];
